import { getValidToken } from '../utils/tokenUtils';
import { buildErrorFromResponse } from './apiHelpers';

export const fetchRelevantTkbRules = async (testResultId) => {
  const token = await getValidToken();
  if (!token) return [];

  const res = await fetch(`/api/test-results/${testResultId}/relevant-tkb-rules`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    console.warn(`TKB rules unavailable for test result ${testResultId}: ${res.status}`);
    return [];
  }

  return res.json();
};

export const fetchAllTkbRules = async () => {
  const token = await getValidToken();
  const res = await fetch('/api/tkb-rules', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte hämta TKB-regler: ${res.status}`);
  return res.json();
};

export const uploadTkbDocument = async (file) => {
  const token = await getValidToken();
  const body = new FormData();
  body.append('file', file);
  const res = await fetch('/api/tkb-rules/upload', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body,
  });
  if (!res.ok) {
    throw await buildErrorFromResponse(res);
  }
  return res.json();
};

export const deleteTkbRules = async (id) => {
  const token = await getValidToken();
  const res = await fetch(`/api/tkb-rules/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Borttagning misslyckades: ${res.status}`);
};
